<template lang="pug">
.form-residential-plans
    .form-residential-plans__prices
        PlanPrices

    .form-residential-plans__images
        .form-residential-plans__form(
            v-for="(plan, index) in plansWithEmpty"
        )
            PlanEmpty(
                v-if="!plan"
                @uploaded="addPlans"
            )

            PlanForm(
                v-else
                :value="plansWithEmpty[index]"
                :itemsRooms="getItemsRooms"
                @input="val => changePlan(val, index)"
                @remove="remove(index)"
            )
</template>

<script>
import PlanPrices from '@/components/forms/subforms/PlanPrices.vue';
import PlanEmpty from '@/components/forms/subforms/PlanEmpty.vue';
import PlanForm from '@/components/forms/subforms/PlanForm.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'FormResidentialPlans',

  computed: {
    ...mapGetters({
      current: 'residential/getCurrent',
      getItemsRooms: 'getItemsRooms',
    }),

    layouts: {
      get() {
        return this.current.layouts;
      },

      set(layouts) {
        this.setValue({ layouts });
      },
    },

    plansWithEmpty() {
      return [...this.layouts, null];
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'residential/setValue',
    }),

    addPlans(val) {
      const res = val.map(original_image => ({
        original_image,
        rooms_id: null,
        area: 0,
        floors: '',
        has_balcony: false,
      }));
      this.layouts = [...this.layouts, ...res];
    },

    remove(index) {
      this.layouts.splice(index, 1);
    },

    changePlan(val, index) {
      this.layouts.splice(index, 1, { ...val });
    },
  },

  components: {
    PlanEmpty,
    PlanForm,
    PlanPrices,
  },
};
</script>

<style lang="scss">
.form-residential-plans {
    padding: 50px;

    .sv-input__wrapper {
      width: 100%;
    }

    &__images {
        display: grid;
        grid-template-columns: repeat(4, 260px);
        grid-gap: 30px;
        margin-top: 50px;
    }
}
</style>
